export var ContactEventType;
(function (ContactEventType) {
    /** When the contact was frozen */
    ContactEventType["FROZEN"] = "frozen";
    /** When the contact was unfrozen */
    ContactEventType["UNFROZEN"] = "unfrozen";
})(ContactEventType || (ContactEventType = {}));
//# sourceMappingURL=contactEvent.js.map